import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "Farm config:", -1)
const _hoisted_3 = { class: "mb-2 ml-5" }
const _hoisted_4 = { class: "mb-2 ml-5" }
const _hoisted_5 = { class: "mb-2 ml-5" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { class: "mb-5" }
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { class: "flex-1 mr-5" }
const _hoisted_11 = { class: "flex-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RewardDisplay = _resolveComponent("RewardDisplay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, "Associated bank: " + _toDisplayString(_ctx.farmAcc.bank), 1),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, " Min staking period: " + _toDisplayString(_ctx.farmAcc.config.minStakingPeriodSec) + " sec ", 1),
    _createElementVNode("div", _hoisted_4, " Cooldown period: " + _toDisplayString(_ctx.farmAcc.config.cooldownPeriodSec) + " sec ", 1),
    _createElementVNode("div", _hoisted_5, " Unstaking fee: " + _toDisplayString(_ctx.farmAcc.config.unstakingFeeLamp) + " lamp ", 1),
    _createElementVNode("div", _hoisted_6, "Initialized farmer count: " + _toDisplayString(_ctx.farmAcc.farmerCount), 1),
    _createElementVNode("div", _hoisted_7, "Staked farmer count: " + _toDisplayString(_ctx.farmAcc.stakedFarmerCount), 1),
    _createElementVNode("div", _hoisted_8, "Gems staked: " + _toDisplayString(_ctx.farmAcc.gemsStaked), 1),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_RewardDisplay, {
          key: _ctx.farmAcc.rewardA,
          reward: _ctx.farmAcc.rewardA,
          title: "Reward A"
        }, null, 8, ["reward"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_RewardDisplay, {
          key: _ctx.farmAcc.rewardB,
          reward: _ctx.farmAcc.rewardB,
          title: "Reward B"
        }, null, 8, ["reward"])
      ])
    ])
  ], 64))
}